<template>
  <div class="container">
    <van-skeleton title avatar :row="30" :loading="loading">
      <van-nav-bar
          left-arrow
          :title="prodInfo.name"
          @click-left="$router.push({name: 'main'})"
          left-text="">
      </van-nav-bar>
      <div>
        <!--顶部 _420,w_630-->
        <van-swipe :autoplay="3000" :touchable="true" v-if="prodInfo.pics">
          <van-swipe-item v-for="(image, index) in prodInfo.pics.split(',')" :key="index">
            <img v-lazy="$getFileAccessHttpUrl(image)" style="height: 350px;width: 100%"/>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div style="background-color: white">
        <div style="padding-top:1px;background-color: white;">
          <div style="margin: 20px 20px 10px 20px">
            <div style="font-size:14pt;">{{ prodInfo.name }}</div>
            <van-divider/>

            <div style="margin-top: -5px">
              <van-row>
                <van-col span="17">
                  <div style="font-size: 10pt;color: gray" class="text-over">
                    <span v-if="prodInfo.typeFlag===10||prodInfo.typeFlag===20||prodInfo.typeFlag===30"> 金额：</span>
                    <span v-else> 爱心：</span>
                    <span
                        style="font-size: 15pt;color: red;height: 30px;line-height: 30px;">
                    <span v-if="prodInfo.typeFlag===10||prodInfo.typeFlag===20||prodInfo.typeFlag===30">{{
                        prodInfo.amount
                      }}</span>
                    <span v-else>{{ prodInfo.price }}</span>
                  </span>
                    <span v-if="prodInfo.typeFlag===10||prodInfo.typeFlag===20||prodInfo.typeFlag===30">  已有{{
                        prodInfo.readCount
                      }}人预定</span>
                  </div>
                </van-col>
                <van-col span="7">
                  <div style="font-size: 10pt;color: gray;text-align: right;height: 30px;line-height: 30px;"
                       class="text-over">
                    剩余：{{ prodInfo.stock }}
                  </div>
                </van-col>
              </van-row>
            </div>
            <van-divider style="border-color:#d4d4d5;margin-top: 5px"/>
            <div style="margin-top: -10px;font-size: 9pt;color:gray">
              本商品为预定服务不支持退款，请谨慎下单，预定金长期有效。
            </div>
          </div>
        </div>
      </div>
      <div class="content" v-if="prodExtraFlag===30" style="color: red;text-align: center">
        <span v-if="jielongOverFlag===1">倒计时已结束</span>
        <span v-if="jielongOverFlag===0">倒计时：{{ daoJiShiString }}</span>
      </div>
      <div style="margin-top: 10px">
        <div class="content" v-if="prodExtraFlag!==30">
          <div v-html="$imgCheck(prodInfo.descn)"></div>
          <br> <br> <br>
        </div>
        <div class="content" v-if="prodExtraFlag===30">
          <div style="margin: 0px;background-color: white;border-radius: 5px;font-size: 11pt">
            <van-row
                style="padding-top: 5px;padding-bottom: 5px;padding-left: 5px;padding-right: 5px;font-weight: bold">
              <van-col span="2" style="text-align: center;height: 30px;line-height: 30px">
                顺序
              </van-col>
              <van-col span="10" style="text-align: center;height: 30px;line-height: 30px">
                昵称
              </van-col>
              <van-col span="10" style="text-align: center;height: 30px;line-height: 30px">
                日期
              </van-col>
              <van-col span="2" style="text-align: center;height: 30px;line-height: 30px">
                数量
              </van-col>
            </van-row>
            <van-row style="padding-top: 10px;padding-bottom: 5px;" v-for="(item ,index) in jielongList" :key="item.id">
              <van-col span="2" style="text-align: center;height: 50px;line-height: 50px">
                {{ index + 1 }}
              </van-col>
              <van-col span="4" style="text-align: right;height: 50px;line-height: 50px">
                <van-image round
                           :src="$getFileAccessHttpUrl(item.avatar)"
                           width="50px" height="50px">
                </van-image>
              </van-col>
              <van-col span="6"
                       style="text-align: left;height: 50px;line-height: 50px;    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;">
                <span style="padding-left:5px">{{ item.nickname }}</span>
              </van-col>
              <van-col span="10" style="text-align: center;height: 50px;line-height: 50px">
                {{ item.createT }}
              </van-col>
              <van-col span="2" style="text-align: center;height: 50px;line-height: 50px">
                {{ item.counts }}
              </van-col>
            </van-row>
          </div>
          <br> <br> <br>
        </div>
      </div>
      <div id="floating-button" @click="goSanRenOrder" v-if="sanRenTuanOrderSn">
        <div style="font-size: 12pt;">分享<br>3人团</div>
      </div>
      <van-goods-action>
        <van-goods-action-icon icon="share-o" v-if="buyFlag" text="分享" @click="goHaiBao"/>
        <van-goods-action-icon icon="chat-o" text="客服" @click="callMobile"/>
        <van-goods-action-icon icon="shop-o" text="店铺" @click="goShopIndex"/>
        <div style="width: 100%" v-if="prodExtraFlag===10">
          <van-row>
            <van-col span="12" @click="skuShow=true">
              <div style="background: #e36060;height: 50px;text-align: center;color:white">
                <div>¥{{ prodInfo.amountNormal }}</div>
                <div style="margin-top: -5px;font-weight: bold">单独购买</div>
              </div>
            </van-col>
            <van-col span="12" @click="skuShow=true">
              <div style="background: red;height: 50px;text-align: center;color:white">
                <div>¥{{ prodInfo.amountSan }}</div>
                <div style="margin-top: -5px;font-weight: bold" v-if="countActive===-1">3人团专享</div>
                <div style="margin-top: -5px;font-weight: bold" v-if="countActive>-1">还差{{ countActive }}人</div>
              </div>
            </van-col>
          </van-row>
        </div>
        <!--        爱心支付-->
        <van-goods-action-button
            v-if="prodExtraFlag===0"
            type="danger"
            text="立即购买"
            @click="skuShow=true"
        />
        <!--        <div >-->
        <!--          <van-goods-action-button-->
        <!--              v-if="buyFlag"-->
        <!--              type="warning"-->
        <!--              text="立即分享"-->
        <!--              @click="goHaiBao"-->
        <!--          />-->
        <!--        非三人团-->
        <van-goods-action-button
            v-if="prodExtraFlag===20"
            type="danger"
            text="立即购买"
            @click="skuShow=true"
        />
        <!--        接龙-->
        <van-goods-action-button
            v-if="prodExtraFlag===30&&jielongOverFlag===1"
            disabled
            type="danger"
            text="活动已结束"
        />
        <van-goods-action-button
            v-if="prodExtraFlag===30&&jielongOverFlag===0"
            type="danger"
            text="我要接龙"
            @click="skuShow=true"
        />
        <!--        </div>-->
      </van-goods-action>
      <van-sku
          v-model="skuShow"
          :sku="sku"
          :goods="goods"
          :goods-id="100"
          :quota="0"
          :buy-text="buyText"
          :show-add-cart-btn="false"
          :custom-stepper-config="customStepperConfig"
          :message-config="messageConfig"
          @buy-clicked="toWxPay">
        <template #sku-header-price>
          <div class="line3">
            {{ prodInfo.name }}
          </div>
          <!--          本商品为预定服务不支持退款，请谨慎下单，预定金长期有效-->
          <!--        <div class="van-sku__goods-price">-->
          <!--        <span class="van-sku__price-symbol">-->
          <!--           {{ prodInfo.typeFlag === 0 ? '' : '￥' }}-->
          <!--          </span><span class="van-sku__price-num">{{ props.price }}</span>-->
          <!--        </div>-->
        </template>
        <template #sku-body-top>
          <div style="font-size: 9pt;text-align: center;color: gray">
            本商品为预定服务不支持退款，请谨慎下单，预定金长期有效
          </div>
        </template>
        <template #sku-messages>
          <!-- 输入任意文本 -->
          <van-field v-model="acceptName" label="姓名" placeholder="请输入姓名"/>
          <!-- 输入手机号，调起手机号键盘 -->
          <van-field v-model="acceptMobile" type="tel" required label="手机号" placeholder="请输入手机号"/>
          <!-- 允许输入正整数，调起纯数字键盘 -->
          <van-field v-model="acceptAddress" label="地址" placeholder="请输入地址"/>
          <van-field v-model="userRemark" label="备注" placeholder="请输入备注"/>
        </template>
      </van-sku>
      <ToPay ref="toPay" @ok="paySuccess()"></ToPay>
    </van-skeleton>
  </div>
</template>

<script>
import {
  Cell,
  Tag,
  Button,
  Swipe,
  SwipeItem,
  DropdownMenu,
  DropdownItem,
  Card,
  Divider,
  Popup,
  Sku,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton
} from 'vant';
import {postAction} from '@/api/manage';
import {Toast, Dialog} from 'vant'
import {ACCESS_TOKEN} from '@/store/mutation-types'
import Vue from 'vue';
import wx from 'weixin-js-sdk'
import ToPay from '@/view/index/toPay'

export default {
  components: {
    [Cell.name]: Cell,
    [Cell.name]: Cell,
    [Sku.name]: Sku,
    [Divider.name]: Divider,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [DropdownItem.name]: DropdownItem,
    [Swipe.name]: Swipe,
    [DropdownMenu.name]: DropdownMenu,
    [SwipeItem.name]: SwipeItem,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton, ToPay
  },
  data() {
    return {
      sanRenTuanOrderSn: undefined,
      daoJiShiString: undefined,
      activeOverTime: undefined,
      jielongOverFlag: undefined,
      timer: undefined,
      show: false,
      loading: true,
      prodId: this.$route.query.id,
      mui: this.$route.query.mui,
      countActive: -1,
      parentId: this.$route.query.parentId,
      sourceOrderSn: this.$route.query.sourceOrderSn,
      prodExtraFlag: undefined,
      prodInfo: {},
      jielongList: [],
      prodCount: 1,
      buyFlag: false,
      buyText: '立即支付',
      mobile: undefined,
      skuShow: false,
      sku: {
        tree: [],
        price: 0, // 默认价格（单位元）
        stock_num: 0, // 商品总库存
        collection_id: this.prodId, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: true, // 是否无规格商品
        hide_stock: false // 是否隐藏剩余库存
      },
      goods: {
        name: 'dd',
        picture: ''
      },
      customStepperConfig: {
        // 步进器变化的回调
        handleStepperChange: currentValue => {
          this.prodCount = currentValue
          if (this.prodInfo.typeFlag === 0) {
            this.buyText = '立即支付' + (parseInt(currentValue) * parseInt(this.prodInfo.price)) + '爱心'
          } else {
            this.buyText = '立即支付' + (parseInt(currentValue) * this.prodInfo.amount).toFixed(2) + '元预定金'
          }
        }
      },
      acceptName: '',
      acceptMobile: '',
      acceptAddress: '',
      userRemark: '',
      messageConfig: {
        // 数据结构见下方文档
      },
    };
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  mounted() {
    const that = this
    that.prodInfoData()
    that.getLastOrderData();
  },
  watch: {
    '$route'(to, from) {
      console.log('onroute', this.$route.query)
      this.id = this.$route.query.id
      // 在mounted函数执行的方法，放到该处
      if (this.$route.query.t) {
        const that = this
        that.countActive = -1
        that.sourceOrderSn = undefined
        that.prodInfoData()
        that.getLastOrderData();
      }
    }
  },

  methods: {
    goSanRenOrder() {
      this.$router.push({name: 'account/myOrderInfo', query: {ordersn: this.sanRenTuanOrderSn}});
    },
    goDaoHang() {
      window.location.href = "https://mapapi.qq.com/web/mapComponents/locationMarker/v/index.html?type=0&marker=coord%3A" + this.prodInfo.lat + "%2C" + this.prodInfo.lng + "%3Btitle%3A" + this.prodInfo.name + "&referer=myapp&key=WEFBZ-AIIWD-I2K4P-PB5I3-FWAZZ-2FFML";
    },
    callMobile() {
      window.location.href = 'tel:' + this.mobile
    },
    goShopIndex() {
      this.$router.push({name: 'main'})
    },
    goHaiBao() {
      this.$router.push({
        name: 'haibao', query: {
          prodId: this.prodId,
          prodExtraFlag: 20, sourceOrderSn: undefined
        }
      });
    },
    paySuccess() {

    },
    wxShare(that, userId) {
      // 微信分享配置
      wx.ready(function () {
        wx.updateTimelineShareData({
          title: that.prodInfo.name, // 分享标题
          link: 'http://mjj.meijiajing.top/main?id=' + that.prodId + '&mui=' + that.mui + '&parentId=' + userId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.goods.picture, // 分享图标
          success: function () {
            // 设置成功
          }
        })
        wx.updateAppMessageShareData({
          title: that.prodInfo.name, // 分享标题
          link: 'http://mjj.meijiajing.top/prodInfo?id=' + that.prodId + '&mui=' + that.mui + '&parentId=' + userId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: that.goods.picture, // 分享图标
          desc: that.prodInfo.shareContent,  // 分享描述
          success: function () {
            // 设置成功
          }
        })
      })
    },
    getDaoJiShi() {
      if (this.activeOverTime) {
        // 获取当前时间戳
        const now = +new Date()
        //获取未来某个时刻时间戳
        const end = +new Date(this.activeOverTime)
        debugger
        const time = (end - now) / 1000
        // 获取 hour,min,second
        let day = parseInt(time / 60 / 60 / 24 % 30)
        let hour = parseInt(time / 60 / 60 % 24)
        let min = parseInt(time / 60 % 60)
        let second = parseInt(time % 60)
        // 如果小于10的话，前面补零：8-》08
        hour = hour < 0 ? '00' : (hour < 10 ? '0' + hour : hour)
        min = min < 0 ? '00' : (min < 10 ? '0' + min : min)
        second = second < 0 ? '00' : (second < 10 ? '0' + second : second)
        this.daoJiShiString = (day ? (day + "天") : '') + hour + "时" + min + "分" + second + ""
        if (this.daoJiShiString === '00:00:00') {
          clearTimeout(this.timer);
          this.prodInfoData();
        }
      }
    },
    toWxPay() {
      var that = this
      if (!this.acceptMobile) {
        Toast("请输入手机号");
        return false;
      }
      if (this.acceptMobile.trim().length !== 11) {
        Toast("请输入正确的手机号");
        return false;
      }
      postAction('/web/api/order/createOrder', {
        prodId: that.prodInfo.id,
        count: this.prodCount,
        acceptMobile: this.acceptMobile,
        acceptName: this.acceptName,
        acceptAddress: this.acceptAddress,
        userRemark: this.userRemark,
        sourceOrderSn: this.sourceOrderSn,
        prodExtraFlag: this.prodExtraFlag,
      }).then(function (response) {
        console.log(response.result)
        if (response.result.prodType === 0) {
          //爱心兑换
          that.skuShow = false
          const toast = Toast.success({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: '支付成功',
          })
          let second = 3
          const timer = setInterval(() => {
            second--
            if (second) {
              toast.message = '支付成功'
            } else {
              clearInterval(timer)
              // 手动清除 Toast
              Toast.clear()
              that.$router.push({name: 'account/myOrderInfo', query: {ordersn: response.result.data}})
            }
          }, 1000)
        } else {
          that.skuShow = false
          that.$refs.toPay.toShow(response.result.data);
        }
      })
    },
    prodInfoData() {
      Toast.loading({message: '加载中...'});
      const that = this;
      postAction('/web/api/index/prodInfoData', {
        prodId: this.prodId,
        parentId: this.parentId,
        sourceOrderSn: this.sourceOrderSn
      }).then(function (response) {
        console.log(response.result)
        that.countActive = response.result.countActive
        that.prodInfo = response.result.product
        that.sanRenTuanOrderSn = response.result.sanRenTuanOrderSn
        that.prodExtraFlag = response.result.prodExtraFlag
        that.goods.picture = that.$getFileAccessHttpUrl(that.prodInfo.listPic)
        that.sku.price = that.prodInfo.typeFlag === 0 ? that.prodInfo.price : that.prodInfo.amount
        Toast.clear()
        that.loading = false
        that.buyText = '立即支付' + that.sku.price + (that.prodInfo.typeFlag === 0 ? '爱心' : '元预定金')
        that.sku.stock_num = that.prodInfo.stock
        that.buyFlag = response.result.buyFlag
        that.jielongList = response.result.jielongList
        that.mobile = response.result.mobile
        document.title = that.prodInfo.name
        that.wxShare(that, response.result.userId);

        if (that.prodInfo.typeFlag === 30) {
          that.activeOverTime = response.result.product.jielongOvertime
          that.jielongOverFlag = response.result.jielongOverFlag
          if (that.jielongOverFlag === 0) {
            that.getDaoJiShi();
            that.timer = setInterval(() => {
              that.getDaoJiShi();
            }, 1000)
          }

        }
        if (that.countActive === -2) {
          //已完成
          Dialog.alert({
            message: '活动已结束！',
          }).then(() => {
            that.$router.replace({name: 'prodInfo', query: {id: that.prodId, t: Date.now()}});
          });
        } else if (that.countActive === -3) {
          //到期了 未完成
          Dialog.alert({
            message: '活动已结束，可发起三人团或单独购买！',
          }).then(() => {
            that.$router.replace({name: 'prodInfo', query: {id: that.prodId, t: Date.now()}});
          });
        } else if (that.countActive === -4) {
          //到期了 未完成
          Dialog.alert({
            message: '您已参与拼团，无需重复下单!',
          }).then(() => {
            that.$router.replace({name: 'prodInfo', query: {id: that.prodId, t: Date.now()}});
          });
        }
      })
    },
    getLastOrderData() {
      const that = this;
      postAction('/web/api/index/getLastOrderData', {}).then(function (response) {
        console.log(response.result)
        if (response.result.ordersData) {
          that.acceptAddress = response.result.ordersData.acceptAddress;
          that.acceptName = response.result.ordersData.acceptName;
          that.acceptMobile = response.result.ordersData.acceptMobile;
        }
      })
    },
  }
};
</script>

<style lang="less">
.container {
  //background-color: #f3f3f385;
}

.content {
  margin: 10px;
}

.content img {
  max-width: 100%;
  display: block;
  float: left
}

#floating-button {
  position: fixed;
  bottom: 80px;
  right: 20px;
  background-color: #f60950;
  color: #fff;
  border: none;
  text-align: center;
  font-size: 15pt;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 9999;
}
</style>
